import { render, staticRenderFns } from "./OnSiteMessageContentWrapper.vue?vue&type=template&id=0bbb8503&"
import script from "./OnSiteMessageContentWrapper.vue?vue&type=script&lang=js&"
export * from "./OnSiteMessageContentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports